<script setup lang="ts">
const { y } = useWindowScroll({ behavior: "smooth" });
</script>

<template>
	<button
		v-if="y > 100"
		class="fixed bottom-11 right-8 border border-gray bg-white rounded-full w-9 h-9 flex items-center justify-center z-50 sm:hidden xs:hidden"
		@click="y = 0"
	>
		<Icon name="teenyicons:up-solid" size="16" class="text-black" />
	</button>
</template>
